import { datadogRum } from "@datadog/browser-rum";

export function reportError(
  error: unknown,
  context?: Record<string, unknown>
) {
  console.error(error);
  try {
    datadogRum.addError(
      error instanceof Error ? error : new Error(String(error)),
      context
    );
  } catch {
    // RUM not initialized
  }
}
